<script>
  import { fly } from 'svelte/transition';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate } from 'svelte-navigator';
  const navigate = useNavigate();
  // export let step;
  import BtnInfo from '../BtnInfo/BtnInfo.svelte';

  import { coordonnees } from '../stores.js';

  console.log($coordonnees);

  // if ($coordonnees['asNom'].length === 0) {
  // $coordonnees['asNom'] = 'Guillaume';
  // $coordonnees['asPrenom'] = 'Arnaud';
  // $coordonnees['asEmail'] = 'test@test.com';
  // $coordonnees['asTel'] = '04567845';
  // $coordonnees['asAdresse'] = '3 rue perdu';
  // $coordonnees['asCp'] = '75000';
  // $coordonnees['asVille'] = 'Paris';
  // $coordonnees['asPays'] = 'FR';
  // $coordonnees['asRevendeur'] = 'Leroy Merlin';
  // }

  function validForm() {
    //as-post-email as-post-tel qs-post-adresse as-post-cp
    const postNom = document.querySelector('[name="as-post-nom"]').value.trim();
    const postPrenom = document
      .querySelector('[name="as-post-prenom"]')
      .value.trim();
    const postEmail = document
      .querySelector('[name="as-post-email"]')
      .value.trim();
    const postTel = document.querySelector('[name="as-post-tel"]').value.trim();
    const postAdresse = document
      .querySelector('[name="as-post-adresse"]')
      .value.trim();
    const postPCp = document.querySelector('[name="as-post-cp"]').value.trim();
    const postVille = document
      .querySelector('[name="as-post-ville"]')
      .value.trim();
    const postPays = document
      .querySelector('[name="as-post-pays"]')
      .value.trim();
    const postRevendeur = document
      .querySelector('[name="as-post-revendeur"]')
      .value.trim();

    const post = [
      postNom,
      postPrenom,
      postEmail,
      postTel,
      postAdresse,
      postPCp,
      postVille,
      postPays,
    ];

    const erroMessage = document.querySelector('#errorMessage');
    erroMessage.textContent = '';
    document.querySelector('[name="as-post-cp"]').style.border =
      '0px solid red';

    let isNotEmpty = true;
    for (var i = 0; i < post.length; i++) {
      if (post[i].length === 0)
        erroMessage.textContent =
          'Vous devez remplir tous les champs obligatoires';
      // if (i === 4) return i;
    }

    if (erroMessage.textContent.length === 0) {
      if (postPCp.length !== 5) {
        erroMessage.textContent = 'Le code postal doit être de 5 chiffres';
        document.querySelector('[name="as-post-cp"]').style.border =
          '1px solid red';
      }
    }

    if (erroMessage.textContent.length === 0) {
      $coordonnees['asNom'] = postNom;
      $coordonnees['asPrenom'] = postPrenom;
      $coordonnees['asEmail'] = postEmail;
      $coordonnees['asTel'] = postTel;
      $coordonnees['asAdresse'] = postAdresse;
      $coordonnees['asCp'] = postPCp;
      $coordonnees['asVille'] = postVille;
      $coordonnees['asPays'] = postPays;
      $coordonnees['asRevendeur'] = postRevendeur;
      console.log($coordonnees);
      asnavigate(navigate, '/process/particulier/recapitulatif');
    }
  }
</script>

<div class="as-container-neu">

  <BtnInfo /> 
  
  <form on:submit|preventDefault="{validForm}">
    <div id="errorMessage" class="text-center mb-12 error"></div>

    <div class="grid grid-cols-2 ">
      <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
        <div class="as-label-neu">Nom*</div>
        <input
          required
          name="as-post-nom"
          value="{$coordonnees.asNom}"
          type="text"
          class="as-input-neu"
          placeholder="Votre nom"
        />
      </div>
      <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
        <div class="as-label-neu">Prénom*</div>
        <input
          required
          name="as-post-prenom"
          value="{$coordonnees.asPrenom}"
          type="text"
          class="as-input-neu"
          placeholder="Votre prénom"
        />
      </div>
      <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
        <div class="as-label-neu">Adresse email*</div>
        <input
          required
          name="as-post-email"
          value="{$coordonnees.asEmail}"
          type="email"
          class="as-input-neu"
          placeholder="Votre adresse email"
        />
      </div>
      <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
        <div class="as-label-neu">Téléphone*</div>
        <input
          required
          name="as-post-tel"
          value="{$coordonnees.asTel}"
          type="text"
          class="as-input-neu"
          placeholder="Votre téléphone"
        />
      </div>
      <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
        <div class="as-label-neu">Adresse*</div>
        <input
          required
          name="as-post-adresse"
          value="{$coordonnees.asAdresse}"
          type="text"
          class="as-input-neu"
          placeholder="Votre adresse"
        />
      </div>
      <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
        <div class="as-label-neu">Code postal*</div>
        <input
          required
          name="as-post-cp"
          value="{$coordonnees.asCp}"
          type="number"
          class="as-input-neu"
          placeholder="Votre code postal"
          maxlength="5"
          minlength="5"
        />
      </div>

      <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
        <div class="as-label-neu">Ville*</div>
        <input
          required
          name="as-post-ville"
          value="{$coordonnees.asVille}"
          type="text"
          class="as-input-neu"
          placeholder="Votre Ville"
        />
      </div>

      <div in:fly="{{ delay: 500, x: 100, duration: 800 }}">
        <div class="as-label-neu">Pays*</div>
        <select name="as-post-pays" class="as-input-neu">
          <option value="FR">France</option>
          <option value="BE">Belgique</option>
          <option value="LU">Luxembourg</option>
          <option value="CH">Suisse</option>
          <option value="AF">Afghanistan</option>
          <option value="AX">Åland Islands</option>
          <option value="AL">Albania</option>
          <option value="DZ">Algeria</option>
          <option value="AS">American Samoa</option>
          <option value="AD">Andorra</option>
          <option value="AO">Angola</option>
          <option value="AI">Anguilla</option>
          <option value="AQ">Antarctica</option>
          <option value="AG">Antigua and Barbuda</option>
          <option value="AR">Argentina</option>
          <option value="AM">Armenia</option>
          <option value="AW">Aruba</option>
          <option value="AU">Australia</option>
          <option value="AT">Austria</option>
          <option value="AZ">Azerbaijan</option>
          <option value="BS">Bahamas (the)</option>
          <option value="BH">Bahrain</option>
          <option value="BD">Bangladesh</option>
          <option value="BB">Barbados</option>
          <option value="BY">Belarus</option>
          <option value="BE">Belgium</option>
          <option value="BZ">Belize</option>
          <option value="BJ">Benin</option>
          <option value="BM">Bermuda</option>
          <option value="BT">Bhutan</option>
          <option value="BO">Bolivia (Plurinational State of)</option>
          <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
          <option value="BA">Bosnia and Herzegovina</option>
          <option value="BW">Botswana</option>
          <option value="BV">Bouvet Island</option>
          <option value="BR">Brazil</option>
          <option value="IO">British Indian Ocean Territory (the)</option>
          <option value="BN">Brunei Darussalam</option>
          <option value="BG">Bulgaria</option>
          <option value="BF">Burkina Faso</option>
          <option value="BI">Burundi</option>
          <option value="CV">Cabo Verde</option>
          <option value="KH">Cambodia</option>
          <option value="CM">Cameroon</option>
          <option value="CA">Canada</option>
          <option value="KY">Cayman Islands (the)</option>
          <option value="CF">Central African Republic (the)</option>
          <option value="TD">Chad</option>
          <option value="CL">Chile</option>
          <option value="CN">China</option>
          <option value="CX">Christmas Island</option>
          <option value="CC">Cocos (Keeling) Islands (the)</option>
          <option value="CO">Colombia</option>
          <option value="KM">Comoros (the)</option>
          <option value="CD">Congo (the Democratic Republic of the)</option>
          <option value="CG">Congo (the)</option>
          <option value="CK">Cook Islands (the)</option>
          <option value="CR">Costa Rica</option>
          <option value="HR">Croatia</option>
          <option value="CU">Cuba</option>
          <option value="CW">Curaçao</option>
          <option value="CY">Cyprus</option>
          <option value="CZ">Czechia</option>
          <option value="CI">Côte d'Ivoire</option>
          <option value="DK">Denmark</option>
          <option value="DJ">Djibouti</option>
          <option value="DM">Dominica</option>
          <option value="DO">Dominican Republic (the)</option>
          <option value="EC">Ecuador</option>
          <option value="EG">Egypt</option>
          <option value="SV">El Salvador</option>
          <option value="GQ">Equatorial Guinea</option>
          <option value="ER">Eritrea</option>
          <option value="EE">Estonia</option>
          <option value="SZ">Eswatini</option>
          <option value="ET">Ethiopia</option>
          <option value="FK">Falkland Islands (the) [Malvinas]</option>
          <option value="FO">Faroe Islands (the)</option>
          <option value="FJ">Fiji</option>
          <option value="FI">Finland</option>
          <option value="FR">France</option>
          <option value="GF">French Guiana</option>
          <option value="PF">French Polynesia</option>
          <option value="TF">French Southern Territories (the)</option>
          <option value="GA">Gabon</option>
          <option value="GM">Gambia (the)</option>
          <option value="GE">Georgia</option>
          <option value="DE">Germany</option>
          <option value="GH">Ghana</option>
          <option value="GI">Gibraltar</option>
          <option value="GR">Greece</option>
          <option value="GL">Greenland</option>
          <option value="GD">Grenada</option>
          <option value="GP">Guadeloupe</option>
          <option value="GU">Guam</option>
          <option value="GT">Guatemala</option>
          <option value="GG">Guernsey</option>
          <option value="GN">Guinea</option>
          <option value="GW">Guinea-Bissau</option>
          <option value="GY">Guyana</option>
          <option value="HT">Haiti</option>
          <option value="HM">Heard Island and McDonald Islands</option>
          <option value="VA">Holy See (the)</option>
          <option value="HN">Honduras</option>
          <option value="HK">Hong Kong</option>
          <option value="HU">Hungary</option>
          <option value="IS">Iceland</option>
          <option value="IN">India</option>
          <option value="ID">Indonesia</option>
          <option value="IR">Iran (Islamic Republic of)</option>
          <option value="IQ">Iraq</option>
          <option value="IE">Ireland</option>
          <option value="IM">Isle of Man</option>
          <option value="IL">Israel</option>
          <option value="IT">Italy</option>
          <option value="JM">Jamaica</option>
          <option value="JP">Japan</option>
          <option value="JE">Jersey</option>
          <option value="JO">Jordan</option>
          <option value="KZ">Kazakhstan</option>
          <option value="KE">Kenya</option>
          <option value="KI">Kiribati</option>
          <option value="KP">Korea (the Democratic People's Republic of)</option
          >
          <option value="KR">Korea (the Republic of)</option>
          <option value="KW">Kuwait</option>
          <option value="KG">Kyrgyzstan</option>
          <option value="LA">Lao People's Democratic Republic (the)</option>
          <option value="LV">Latvia</option>
          <option value="LB">Lebanon</option>
          <option value="LS">Lesotho</option>
          <option value="LR">Liberia</option>
          <option value="LY">Libya</option>
          <option value="LI">Liechtenstein</option>
          <option value="LT">Lithuania</option>
          <option value="LU">Luxembourg</option>
          <option value="MO">Macao</option>
          <option value="MG">Madagascar</option>
          <option value="MW">Malawi</option>
          <option value="MY">Malaysia</option>
          <option value="MV">Maldives</option>
          <option value="ML">Mali</option>
          <option value="MT">Malta</option>
          <option value="MH">Marshall Islands (the)</option>
          <option value="MQ">Martinique</option>
          <option value="MR">Mauritania</option>
          <option value="MU">Mauritius</option>
          <option value="YT">Mayotte</option>
          <option value="MX">Mexico</option>
          <option value="FM">Micronesia (Federated States of)</option>
          <option value="MD">Moldova (the Republic of)</option>
          <option value="MC">Monaco</option>
          <option value="MN">Mongolia</option>
          <option value="ME">Montenegro</option>
          <option value="MS">Montserrat</option>
          <option value="MA">Morocco</option>
          <option value="MZ">Mozambique</option>
          <option value="MM">Myanmar</option>
          <option value="NA">Namibia</option>
          <option value="NR">Nauru</option>
          <option value="NP">Nepal</option>
          <option value="NL">Netherlands (the)</option>
          <option value="NC">New Caledonia</option>
          <option value="NZ">New Zealand</option>
          <option value="NI">Nicaragua</option>
          <option value="NE">Niger (the)</option>
          <option value="NG">Nigeria</option>
          <option value="NU">Niue</option>
          <option value="NF">Norfolk Island</option>
          <option value="MP">Northern Mariana Islands (the)</option>
          <option value="NO">Norway</option>
          <option value="OM">Oman</option>
          <option value="PK">Pakistan</option>
          <option value="PW">Palau</option>
          <option value="PS">Palestine, State of</option>
          <option value="PA">Panama</option>
          <option value="PG">Papua New Guinea</option>
          <option value="PY">Paraguay</option>
          <option value="PE">Peru</option>
          <option value="PH">Philippines (the)</option>
          <option value="PN">Pitcairn</option>
          <option value="PL">Poland</option>
          <option value="PT">Portugal</option>
          <option value="PR">Puerto Rico</option>
          <option value="QA">Qatar</option>
          <option value="MK">Republic of North Macedonia</option>
          <option value="RO">Romania</option>
          <option value="RU">Russian Federation (the)</option>
          <option value="RW">Rwanda</option>
          <option value="RE">Réunion</option>
          <option value="BL">Saint Barthélemy</option>
          <option value="SH"
            >Saint Helena, Ascension and Tristan da Cunha</option
          >
          <option value="KN">Saint Kitts and Nevis</option>
          <option value="LC">Saint Lucia</option>
          <option value="MF">Saint Martin (French part)</option>
          <option value="PM">Saint Pierre and Miquelon</option>
          <option value="VC">Saint Vincent and the Grenadines</option>
          <option value="WS">Samoa</option>
          <option value="SM">San Marino</option>
          <option value="ST">Sao Tome and Principe</option>
          <option value="SA">Saudi Arabia</option>
          <option value="SN">Senegal</option>
          <option value="RS">Serbia</option>
          <option value="SC">Seychelles</option>
          <option value="SL">Sierra Leone</option>
          <option value="SG">Singapore</option>
          <option value="SX">Sint Maarten (Dutch part)</option>
          <option value="SK">Slovakia</option>
          <option value="SI">Slovenia</option>
          <option value="SB">Solomon Islands</option>
          <option value="SO">Somalia</option>
          <option value="ZA">South Africa</option>
          <option value="GS"
            >South Georgia and the South Sandwich Islands</option
          >
          <option value="SS">South Sudan</option>
          <option value="ES">Spain</option>
          <option value="LK">Sri Lanka</option>
          <option value="SD">Sudan (the)</option>
          <option value="SR">Suriname</option>
          <option value="SJ">Svalbard and Jan Mayen</option>
          <option value="SE">Sweden</option>
          <option value="CH">Switzerland</option>
          <option value="SY">Syrian Arab Republic</option>
          <option value="TW">Taiwan (Province of China)</option>
          <option value="TJ">Tajikistan</option>
          <option value="TZ">Tanzania, United Republic of</option>
          <option value="TH">Thailand</option>
          <option value="TL">Timor-Leste</option>
          <option value="TG">Togo</option>
          <option value="TK">Tokelau</option>
          <option value="TO">Tonga</option>
          <option value="TT">Trinidad and Tobago</option>
          <option value="TN">Tunisia</option>
          <option value="TR">Turkey</option>
          <option value="TM">Turkmenistan</option>
          <option value="TC">Turks and Caicos Islands (the)</option>
          <option value="TV">Tuvalu</option>
          <option value="UG">Uganda</option>
          <option value="UA">Ukraine</option>
          <option value="AE">United Arab Emirates (the)</option>
          <option value="GB"
            >United Kingdom of Great Britain and Northern Ireland (the)</option
          >
          <option value="UM">United States Minor Outlying Islands (the)</option>
          <option value="US">United States of America (the)</option>
          <option value="UY">Uruguay</option>
          <option value="UZ">Uzbekistan</option>
          <option value="VU">Vanuatu</option>
          <option value="VE">Venezuela (Bolivarian Republic of)</option>
          <option value="VN">Viet Nam</option>
          <option value="VG">Virgin Islands (British)</option>
          <option value="VI">Virgin Islands (U.S.)</option>
          <option value="WF">Wallis and Futuna</option>
          <option value="EH">Western Sahara</option>
          <option value="YE">Yemen</option>
          <option value="ZM">Zambia</option>
          <option value="ZW">Zimbabwe</option>
        </select>
      </div>

      <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
        <div class="as-label-neu">
          Votre magasin habituel revendeur de produits Semin
        </div>
        <input
          name="as-post-revendeur"
          value="{$coordonnees.asRevendeur}"
          type="text"
          class="as-input-neu"
          placeholder="Votre magasin habituel de produits Semin"
        />
      </div>

      <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
        <!-- <div class="as-btn-rounded" on:click="{() => validForm()}">
          Continuer
        </div> -->
        <button type="submit" class="as-btn-rounded"> Continuer </button>
      </div>
    </div>
  </form>
</div>

<style>
  select {
    background-image: linear-gradient(45deg, transparent 50%, #545454 50%),
      linear-gradient(135deg, #545454 50%, transparent 50%);
    background-position: calc(100% - 30px) calc(1em + 12px),
      calc(100% - 25px) calc(1em + 12px);
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
  }
  .error {
    /* font-family: 'introlight'; */
    color: red;
  }
  @media only screen and (max-width: 768px) {
    .as-container-neu {
      padding: 10px 40px;
    }
    .grid-cols-2 {
      display: block;
    }
    .grid-cols-2 > div {
      margin-bottom: 40px;
    }
    .as-btn-rounded {
      margin-top: 5px;
      margin-bottom: 20px;
    }
  }
</style>
